import { IEmailPerformanceParams, IEmailPerformanceResponse } from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';

export type IFetchEmailPerformanceArgs = IEmailPerformanceParams & {
  organisationId: string;
};

export const emailPerformanceApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchEmailPerformance: builder.query<IEmailPerformanceResponse, IFetchEmailPerformanceArgs>({
      query: ({ organisationId, ...params }) => ({
        url: `email-performance`,
        method: `GET`,
        params,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
    }),
  }),
});

export const {
  useFetchEmailPerformanceQuery,
} = emailPerformanceApi;
